<template>
    <div>
        <a
            v-for="link in links"
            class="kgr-clickable"
            :class="{'kgr-icon--accent': link.value === value}"
            :title="link.title"
            @click="onInput(link.value)"
        >
            <kgr-icon
                :icon-class="link.value"
                big
            />
        </a>
    </div>
</template>

<script>
import Icon from '../../icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        value: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            links: [
                {
                    title: this.$t('View.listViewSwitch'),
                    value: 'list',
                },
                {
                    title: this.$t('View.gridViewSwitch'),
                    value: 'grid',
                },
            ],
        }
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
